/**
 * Formats a number with "K" suffix for thousands when > 1000 (e.g. 1500 -> "1.5K", 1000 -> "1,000").
 * Returns full locale string for values <= 1000, or the value as-is when not a number.
 */
export function formatThousands(value: number | string): string {
  if (typeof value !== 'number') return value;
  if (value > 1000) {
    const k = value / 1000;
    const formatted = k.toFixed(1).replace(/\.0$/, '');
    return `${formatted}K`;
  }
  return value.toLocaleString();
}

export function humanFileSize(size: number, decimals = 0) {
  const i = Math.floor(Math.log(size) / Math.log(1024));

  return (size / Math.pow(1024, i)).toFixed(decimals) + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
}

export function slugify(text: string): string {
  return text
    .toString() // Cast to string
    .toLowerCase() // Convert the string to lowercase letters
    .normalize('NFD') // The normalize() method returns the Unicode Normalization Form of a given string.
    .trim() // Remove whitespace from both sides of a string
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w-]+/g, '') // Remove all non-word chars
    .replace(/--+/g, '-'); // Replace multiple - with single -
}

export const capitalizeFirst = (str: string) => {
  return [str.slice(0, 1).toUpperCase(), str.slice(1)].join('');
};
